'use client';

import React from 'react';
import type { TokenUsageSummary } from '../types';

export interface DevTokenUsageProps {
  summary: TokenUsageSummary | null;
}

/**
 * DEV-only live LLM token readout. Mirrors DevFallbackToggle's styling and is
 * gated by the caller (devToolsVisible + the DEV "Show tokens" toggle). Reads
 * the token usage the backend relays on each `response.done`.
 */
export const DevTokenUsage: React.FC<DevTokenUsageProps> = ({ summary }) => {
  const fmt = (n: number) => n.toLocaleString();
  return (
    <div className="fixed bottom-2 right-2 z-40 rounded bg-white/70 px-2 py-1 text-xs tabular-nums text-neutral-black ring-1 ring-neutral-gray-300">
      <div className="font-semibold">DEV · Tokens</div>
      {summary ? (
        <>
          <div>{`total ${fmt(summary.billedTotalTokens)} · in ${fmt(summary.billedInputTokens)} · out ${fmt(summary.billedOutputTokens)}`}</div>
          <div>{`turns ${summary.responseCount} · ctx peak ${fmt(summary.peakContextInputTokens)}`}</div>
          {summary.billedReasoningTokens > 0 && (
            <div>{`reasoning ${fmt(summary.billedReasoningTokens)}`}</div>
          )}
        </>
      ) : (
        <div className="opacity-70">no usage yet</div>
      )}
    </div>
  );
};
